export default "/wp-content/themes/allen-carr/public/dist/svgs/myaccount-settings.svg";